import { inject, Injectable } from '@angular/core';
import { API_BASE_PUBLIC_URL } from '../utils';
import { BaseHttpService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class BasePublicHttpService extends BaseHttpService {
  override apiBaseUrl = inject(API_BASE_PUBLIC_URL);

  constructor() {
    super();
    this.apiBaseUrl = inject(API_BASE_PUBLIC_URL);
  }
}
